import Vue from 'vue';
import VueRouter from 'vue-router';
import i18n from '@/i18n';
import { syncSeoByRoute } from '@/utils/seo';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HomePage from '../views/HomePage';
import OpenBadgesPage from '../views/OpenBadgesPage';
import IssuancePage from '../views/IssuancePage';
import ManagementPage from '../views/ManagementPage';
// import SampleBadgesPage from '../views/SampleBadgesPage';
import SampleBadgesV3Page from '../views/SampleBadgesV3Page';
import BadgesGalleryPage from '../views/BadgesGalleryPage';
import EducationPage from '../views/EducationPage';
import EnterprisePage from '../views/EnterprisePage';
import AssociationPage from '../views/AssociationPage';
import AboutPage from '../views/AboutPage';
import PressPage from '../views/PressPage';
import NoticePage from '../views/NoticePage';
import NoticeViewPage from '../views/NoticeViewPage';
import ContactPage from '../views/ContactPage';
import UserForOpenbadgePage from '../views/UserForOpenbadgePage';
import UserForOpenbadgeV3Page from '../views/UserForOpenbadgeV3Page';
import PrivacyPage from '../views/PrivacyPage';
import TermsOfServicePage from '../views/TermsOfServicePage';
import NotFoundPage from '../views/NotFoundPage';
import Inquiry from '../components/Inquiry';

import CampaignEntry from '../views/campaigns/CampaignEntry';

// import BannerApp from '../components/BannerApp';
// import SenbadgesPage from '../views/SenbadgesPage';
// import KohveabadgesPage from '../views/KohveabadgesPage';

// import AESKrbadgePage from '../views/AESKrbadgePage';
// import S4edtechbadgePage from '../views/S4edtechbadgePage';
// import AesforumthaiPage from '../views/AesforumthaiPage';
// import Lecoslte2025Page from '../views/Lecoslte2025Page';
// import EduplusweekPage from '../views/EduplusweekPage';
// import AlheforumPage from '../views/AlheforumPage';
// import EduplusshowPage from '../views/EduplusshowPage';
// import Bgwc3lecosbadgePage from '../views/Bgwc3lecosbadgePage';

Vue.use(VueRouter);

const routes = [
    // ✅ 1) 언어-중립 엔트리 라우트가 최상단
    {
        path: '/privacy',
        name: 'PrivacyEntry',
        beforeEnter: (to, from, next) => {
            const lang = detectLang(to);   // 'kor' | 'eng'
            next({ path: `/${lang}/privacy`, query: to.query, hash: to.hash });
        }
    },
    {
        path: '/terms',
        name: 'TermsEntry',
        beforeEnter: (to, from, next) => {
            const lang = detectLang(to);
            next({ path: `/${lang}/terms_of_service`, query: to.query, hash: to.hash });
        }
    },
    {
        path: '/',
        name: 'HomePage',
        redirect: '/kor'
    },
    {
        path: '/:lang',
        name: 'HomePageSelectedLanguage',
        components: {
            header: Header,
            default: HomePage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    // {
    //     path: '/:lang/terms_of_service', // 오픈배지 사이트와 연동중
    //     name: 'TermsOfServicePage', // 이용약관
    //     components: {
    //         header: Header,
    //         default: TermsOfServicePage,
    //         inquiry: Inquiry,
    //         footer: Footer
    //     }
    // },
    // {
    //     path: '/:lang/privacy',
    //     name: 'PrivacyPage', // 개인정보취급방침
    //     components: {
    //         header: Header,
    //         default: PrivacyPage,
    //         inquiry: Inquiry,
    //         footer: Footer
    //     }
    // },
    {
        path: '/:lang/openbadge',
        name: 'OpenbadgesPage',
        components: {
            header: Header,
            default: OpenBadgesPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/openbadge/badge-list',
        name: 'BadgesGalleryPage',
        components: {
            header: Header,
            default: BadgesGalleryPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/service',
        name: 'ServicePage',
        components: {
            header: Header,
            default: IssuancePage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/service/issuance',
        name: 'IssuancePage',
        components: {
            header: Header,
            default: IssuancePage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/service/management',
        name: 'ManagementPage',
        components: {
            header: Header,
            default: ManagementPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    // {
    //     path: '/:lang/service/issuing-sample',
    //     name: 'SampleBadgesPage',
    //     components: {
    //         header: Header,
    //         default: SampleBadgesPage,
    //         inquiry: Inquiry,
    //         footer: Footer
    //     }
    // },
    {
        path: '/:lang/service/issuing-sample-v3',
        name: 'SampleBadgesV3Page',
        components: {
            header: Header,
            default: SampleBadgesV3Page,
            // bannerApp: BannerApp,
            footer: Footer
        }
    },
    // {
    //     path: '/:lang/service/badge-list',
    //     name: 'BadgesGalleryPage',
    //     components: {
    //         header: Header,
    //         default: BadgesGalleryPage,
    //         inquiry: Inquiry,
    //         footer: Footer
    //     }
    // },
    {
        path: '/:lang/solutions',
        name: 'SolutionPage',
        components: {
            header: Header,
            default: EducationPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/solutions/education',
        name: 'EducationPage',
        components: {
            header: Header,
            default: EducationPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/solutions/enterprise',
        name: 'EnterprisePage',
        components: {
            header: Header,
            default: EnterprisePage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/solutions/association',
        name: 'AssociationPage',
        components: {
            header: Header,
            default: AssociationPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/company',
        name: 'CompanyPage',
        components: {
            header: Header,
            default: AboutPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/company/about',
        name: 'AboutPage',
        components: {
            header: Header,
            default: AboutPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/company/press',
        name: 'PressPage',
        components: {
            header: Header,
            default: PressPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/company/event-list',
        name: 'NoticePage',
        components: {
            header: Header,
            default: NoticePage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/company/event-detail',
        name: 'NoticeViewPage',
        components: {
            header: Header,
            default: NoticeViewPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/contact-us',
        name: 'ContactPage',
        components: {
            header: Header,
            default: ContactPage,
            footer: Footer
        }
    },
    {
        path: '/:lang/user-for-openbadge',
        name: 'UserForOpenbadgePage',
        components: {
            header: Header,
            default: UserForOpenbadgePage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/user-for-openbadge-v3',
        name: 'UserForOpenbadgeV3Page',
        components: {
            header: Header,
            default: UserForOpenbadgeV3Page,
            // bannerApp: BannerApp,
            footer: Footer
        }
    },
    // {
    //     path: '/privacy*',
    //     beforeEnter: (to, from, next) => {
    //         const lang = detectLang(to);
    //         next(`/${lang}/privacy`);
    //     }
    // },
    // {
    //     path: '/terms*',
    //     beforeEnter: (to, from, next) => {
    //         const lang = detectLang(to);
    //         next(`/${lang}/terms_of_service`);
    //     }
    // },
    {
        path: '/:lang/terms_of_service', // 오픈배지 사이트와 연동중
        name: 'TermsOfServicePage', // 이용약관
        components: {
            header: Header,
            default: TermsOfServicePage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    {
        path: '/:lang/privacy',
        name: 'PrivacyPage', // 개인정보취급방침
        components: {
            header: Header,
            default: PrivacyPage,
            inquiry: Inquiry,
            footer: Footer
        }
    },
    // ✅ 캠페인(슬러그) 공용 페이지 (항상 맨 아래쪽(=NotFound 바로 위) 추천)
    {
        path: '/:lang/c/:slug',
        name: 'TrialBadgeCampaignPage',
        components: {
            default: CampaignEntry,
        },
        props: { default: true },
    },


    // {
    //     path: '/:lang/senbadges',
    //     name: 'SenbadgesPage',
    //     // component: UserForOpenBadgePage,
    //     components: {
    //         default: SenbadgesPage,
    //         // default: () => import(/* webpackChunkName: "UserForOpenBadgePage" */ '../views/UserForOpenBadgePage.vue'),
    //     },
    //     // props: {
    //     //     default: true
    //     // }
    // },
    // {
    //     path: '/:lang/kohveabadges',
    //     name: 'KohveabadgesPage',
    //     // component: UserForOpenBadgePage,
    //     components: {
    //         default: KohveabadgesPage,
    //         // default: () => import(/* webpackChunkName: "UserForOpenBadgePage" */ '../views/UserForOpenBadgePage.vue'),
    //     },
    //     // props: {
    //     //     default: true
    //     // }
    // },
    // {
    //     path: '/:lang/s4edtechbadge',
    //     name: 'S4edtechbadgePage',
    //     components: {
    //         default: S4edtechbadgePage,
    //     },
    // },
    // {
    //     path: '/:lang/aeskr',
    //     name: 'AESKrbadgePage',
    //     components: {
    //         default: AESKrbadgePage,
    //     },
    // },    
    // {
    //     path: '/:lang/aesforumthai',
    //     name: 'AesforumthaiPage',
    //     components: {
    //         default: AesforumthaiPage,
    //     },
    // },
    // {
    //     path: '/:lang/eduplusweek',
    //     name: 'EduplusweekPage',
    //     components: {
    //         default: EduplusweekPage,
    //     },
    // },
    // {
    //     path: '/:lang/alheforum',
    //     name: 'AlheforumPage',
    //     components: {
    //         default: AlheforumPage,
    //     },
    // },
    // {
    //     path: '/:lang/eduplusshow',
    //     name: 'EduplusshowPage',
    //     components: {
    //         default: EduplusshowPage,
    //     },
    // },
    // {
    //     path: '/:lang/lecoslte2025',
    //     name: 'Lecoslte2025',
    //     components: {
    //         default: Lecoslte2025Page,
    //     },
    // },
    // {
    //     path: '/:lang/bgwc3lecos',
    //     name: 'Bgwc3lecosbadgePage',
    //     components: {
    //         default: Bgwc3lecosbadgePage,
    //     },
    // },

    // ✅ 언어 포함 404
    {
        path: '/:lang(kor|eng)/404',
        name: 'NotFoundPage',
        components: { default: NotFoundPage, footer: Footer },
    },

    // ✅ 그 외는 언어 감지해서 404로 보냄
    {
        path: '*',
        name: 'NotFoundEntry',
        beforeEnter: (to, from, next) => {
            const first = (to.path.split('/')[1] || '').toLowerCase(); // 'eng' or 'kor' or ''
            const lang = (first === 'eng' || first === 'kor') ? first : detectLang(to);
            next({ name: 'NotFoundPage', params: { lang } });
        },
    },
];

// utils/router-lang.js (아니면 router/index.js 상단)
const isValid = v => ['kor','eng'].includes((v||'').toLowerCase());
const pick = v => isValid(v) ? v.toLowerCase() : null;
const shortToLong = v => (v === 'ko' ? 'kor' : v === 'en' ? 'eng' : v);

function browserPreferredLang() {
    const list = (navigator.languages && navigator.languages.length)
        ? navigator.languages : [navigator.language || ''];
    for (const l of list) {
        const code = (l || '').toLowerCase();
        if (code.startsWith('en')) return 'eng';
        if (code.startsWith('ko')) return 'kor';
    }
    return null;
}


function detectLang(to) {
    // 1) 명시 쿼리
    const byQuery = pick(to?.query?.lang); if (byQuery) return byQuery;
    // 2) 경로 파라미터
    const byParam = pick(to?.params?.lang); if (byParam) return byParam;
    // 3) 사용자가 헤더에서 고정 선택한 값 (있다면 최우선)
    const pinned = pick(localStorage.getItem('siteLang')); if (pinned) return pinned;
    // 4) 브라우저 선호
    const br = browserPreferredLang(); if (br) return br;
    // 5) 마지막 폴백: i18n.locale
    const fromI18n = pick(shortToLong((i18n && i18n.locale) || '')); if (fromI18n) return fromI18n;
    return 'kor';
}
export { detectLang };

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        // 특정 라우터 경로에 대한 조건 추가
        if (to.name === 'BadgesGalleryPage' && from.name === 'BadgesGalleryPage') {
            // 같은 페이지에서 검색어만 변경될 경우 스크롤을 유지
            // console.log('savedPosition', savedPosition);
            return savedPosition || { x: 0, y: window.scrollY };
        }
        return { x: 0, y: 0 };
    },
    // scrollBehavior() { 
    //     return { x: 0, y: 0 }; 
    // },
    routes,
});

router.beforeEach((to, from, next) => {
    // 엔트리 라우트는 그대로 통과
    if (to.name === 'PrivacyEntry' || to.name === 'TermsEntry') return next();

    // 1) 루트는 /kor로 (한 번만)
    if (to.path === '/' || to.path === '') return next('/kor');

    // 2) trailing slash 정리: /kor/ -> /kor, /kor/openbadge/ -> /kor/openbadge
    if (to.path.length > 1 && to.path.endsWith('/')) {
        return next({ path: to.path.replace(/\/+$/, ''), query: to.query, hash: to.hash });
    }

    // 3) lang 파라미터가 있는 라우트만 언어 동기화
    const lang = (to.params && to.params.lang) ? String(to.params.lang).toLowerCase() : null;

    // lang이 없는 라우트(예: /privacy, /terms 등)는 통과
    if (!lang) return next();

    // 4) lang 검증
    if (!['kor', 'eng'].includes(lang)) {
        const fallback = detectLang(to);
        return next({ name: 'NotFoundPage', params: { lang: fallback } });
    }

    // 5) i18n + <html lang> 동기화
    const target = (lang === 'kor' ? 'ko' : 'en');
    if (i18n.locale !== target) i18n.locale = target;
    document.documentElement.setAttribute('lang', target);

    return next();
});

router.afterEach(async (to) => {
    // 라우팅 끝난 뒤 SEO 동기화
    await syncSeoByRoute(to);
});

export default router;
